import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import Pagination from "../component/Pagination";
import { AppContext } from "../context/context";

const ErrorLogs = () => {
  //global states
  const { state, fetchErrorLogs } = useContext(AppContext);
  const { errorLogsData } = state;

  //pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  //table loading
  const [loading, setLoading] = useState(true);

  //table data
  const [errorLogsDataLocal, setErrorLogsDataLocal] = useState(errorLogsData);

  //data states
  const [searchInput, setSearchInput] = useState("");
  const [selectedPdf, setSelectedPdf] = useState(null);

  // time interval state
  const [selectedInterval, setSelectedInterval] = useState("1");

  // intervals list (only hours)
  const intervals = [
    { label: "Last 1 Hour", value: "1" },
    { label: "Last 2 Hours", value: "2" },
    { label: "Last 6 Hours", value: "6" },
    { label: "Last 12 Hours", value: "12" },
    { label: "Last 24 Hours", value: "24" },
    { label: "Last 48 Hours", value: "48" },
    { label: "Last 72 Hours", value: "72" }
  ];

  //handle pagination
  const handleChangePage = (page) => {
    setPage(page);
  };

  //handle search input
  const handleChangeSearchInput = (e) => {
    setSearchInput(e.target.value);
    handleSearchPdf(e.target.value);
    setPage(0);
  };

  //handle search functionality
  const handleSearchPdf = (input) => {
    let filteredData = errorLogsData?.filter((item) => {
      return (
        item?.name?.toLowerCase()?.includes(input?.toLowerCase()) ||
        item?.url?.toLowerCase()?.includes(input?.toLowerCase())
      );
    });
    setErrorLogsDataLocal(filteredData);
  };

  //fetch pdf data
  const getData = async () => {
    setLoading(true);
    await fetchErrorLogs({ hour: selectedInterval });
    setLoading(false);
  };

  //set pdf data in local state
  useEffect(() => {
    setErrorLogsDataLocal(errorLogsData);
  }, [errorLogsData]);

  //get pdf data on page load or when interval changes
  useEffect(() => {
    getData();
  }, [state?.activeTab, selectedInterval]);

  return (
    <div className="h-[calc(100%_-_56px)] pb-2 mt-2">
      <div className="flex items-center justify-between">
        <p className="text-lg font-medium text-[#424242] h-[32px]">
          List of Error Logs
        </p>

        {/* Time Interval Dropdown */}
        <div className="relative">
          <select
            value={selectedInterval}
            onChange={(e) => setSelectedInterval(e.target.value)}
            className="bg-gray-100 border border-gray-200 rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            {intervals.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex flex-col gap-2 h-[calc(100%_-_32px)]">
        <div className="w-full relative">
          <img
            className="absolute top-1/2 transform translate-y-[-50%] left-[14px] h-[13px]"
            src={assetsManager.searchIcon}
            alt=""
          />
          <input
            className="lg:w-[24rem] md:min-w-[0] rounded-[4px] p-2 px-9 focus:outline-none bg-[#EFEFEF] text-sm"
            placeholder="Search Error Logs"
            onChange={handleChangeSearchInput}
            value={searchInput}
          />
        </div>
        <div className="h-[calc(100%_-_36px)] overflow-auto relative flex flex-col justify-between">
          <table
            className={`w-full table-fixed min-w-[500px] ${
              errorLogsDataLocal?.length === 0 && "sticky top-0"
            }`}
          >
            <thead className="sticky top-0">
              <tr>
                <th className="border-b-[2px] border-[#EAECF0] text-sm p-3 bg-[#F8F8F8] font-medium text-start">
                  Timestamp
                </th>
                <th className="border-b-[2px] border-[#EAECF0] text-sm p-3 bg-[#F8F8F8] font-medium text-start">
                  Type
                </th>
                <th className="border-b-[2px] border-[#EAECF0] text-sm p-3 bg-[#F8F8F8] font-medium text-start">
                  Outer Message
                </th>
                <th className="border-b-[2px] border-[#EAECF0] text-sm p-3 bg-[#F8F8F8] font-medium text-start">
                  Details
                </th>
                <th className="border-b-[2px] border-[#EAECF0] text-sm p-3 bg-[#F8F8F8] font-medium text-start">
                  Customer Dimensions
                </th>
              </tr>
            </thead>
            <tbody>
              {errorLogsDataLocal?.length > 0 &&
                errorLogsDataLocal
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => {
                    return (
                      <tr className="border-b-[2px] border-[#EAECF0]" key={i}>
                        <td className=" text-sm p-3 text-start">
                          <p
                            title={item.timestamp}
                            className="text-ellipsis text-nowrap overflow-hidden"
                          >
                            {item?.timestamp}
                          </p>
                        </td>
                        <td className=" text-sm p-3 text-start">
                          <p
                            className="text-ellipsis text-nowrap overflow-hidden cursor-pointer w-[90%]"
                            title={item?.type}
                          >
                            {item?.type}
                          </p>
                        </td>
                        <td className=" text-sm p-3 text-start">
                          <p
                            className="text-ellipsis text-nowrap overflow-hidden cursor-pointer w-[90%]"
                            title={item?.outerMessage}
                          >
                            {item?.outerMessage}
                          </p>
                        </td>
                        <td className=" text-sm p-3 text-start">
                          <p
                            className="text-ellipsis text-nowrap overflow-hidden cursor-pointer w-[90%]"
                            title={item?.details}
                          >
                            {item?.details}
                          </p>
                        </td>
                        <td className=" text-sm p-3 text-start">
                          <p
                            className="text-ellipsis text-nowrap overflow-hidden cursor-pointer w-[90%]"
                            title={item?.customDimensions}
                          >
                            {item?.customDimensions}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </table>
          {errorLogsDataLocal?.length === 0 && (
            <div className=" h-[calc(100%_-_36px)] flex items-center justify-center">
              {loading ? (
                "Loading..."
              ) : (
                <img
                  className="h-2/3 min-h-24 max-h-48"
                  src={assetsManager.emptyIllustration}
                  alt=""
                />
              )}
            </div>
          )}
        </div>
        <Pagination
          data={errorLogsDataLocal}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
        />
      </div>
    </div>
  );
};

export default ErrorLogs;
